import React, { useContext, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import AddSomeInfo from "./AddSomeInfo";
import { ContextPro } from "../../../App";
import BtnAdmin from "../BtnAdmin";
import ChooseImg from "../ChooseImg";
import InputComponent from "../InputComponent";

import { adminPanelAPIs } from "../../../utils/config";
import { Based64 } from "../../../utils/convertToBased64";
import { urlApiEd } from "../../../utils/utilsFuc";
import CanvasInCenter from "../../Commons/CanvasInCenter";
import Loader from "../../loader";

export default function AddProduct() {
  const { dataBrand } = useContext(ContextPro);
  const navigate = useNavigate();
  const location = useLocation();
  const [info, setInfo] = useState([]);
  const [load, setLoad] = useState(false);
  const [error, setError] = useState(false);

  const [data, setData] = useState({
    name: "",
    price: 0,
    discount: 0,
    brand: 0,
    description: "",
    outofstock: false,
  });
  const [img, setImg] = useState([]);
  function getImg(imgs) {
    setImg([]);
    imgs?.map((e) => {
      setImg((prev) => [...prev, Based64(e)]);
    });
  }

  return (
    <div className=" container">
      <div className=" brand-data">
        <InputComponent title={"Name"}>
          <input
            type="text"
            value={data.name}
            onChange={(e) => {
              setData({ ...data, name: e.target.value });
            }}
          />
        </InputComponent>
        <InputComponent title={"Price"}>
          <input
            type="number"
            value={data.price}
            onChange={(e) => {
              setData({ ...data, price: e.target.value });
            }}
          />
        </InputComponent>
        <InputComponent title={"Discount"}>
          <input
            type="number"
            value={data.discount}
            onChange={(e) => {
              setData({ ...data, discount: e.target.value });
            }}
          />
        </InputComponent>
        <InputComponent title={"Brands"}>
          <select
            value={data.brand}
            onChange={(e) => {
              setData({ ...data, brand: e.target.value });
            }}
          >
            <option value={null}></option>
            {dataBrand?.map((e) => (
              <option value={e.id}>{e.name}</option>
            ))}
          </select>
        </InputComponent>
        <InputComponent title={"Description"}>
          <textarea
            value={data.description}
            onChange={(e) => {
              setData({ ...data, description: e.target.value });
            }}
          ></textarea>
        </InputComponent>

        <InputComponent title={"Photo File"}>
          <ChooseImg onclick={getImg} />
        </InputComponent>
        <div className=" align-self-center">
          <input
            type="checkbox"
            value={data.outofstock}
            onClick={(e) => {
              setData({ ...data, outofstock: e.target.checked });
            }}
          />
          <label>Out of stock</label>
        </div>
        <AddSomeInfo onclick={setInfo} />
      </div>
      <div className=" d-flex gap-4">
        <BtnAdmin
          title={"Creat"}
          bgcolor="green"
          onclick={() => {
            setLoad(true)
            urlApiEd(adminPanelAPIs.Product.addProductURL, {
              title: data.name,
              description: data.description,
              price: parseInt(data.price),
              discount: parseInt(data.discount),
              outOfStock: data.outofstock,
              categoryId: parseInt(location.state.id),
              brandId: parseInt(data.brand),
            })
              .then((e) => {
                img.forEach((img, i) => {
                  setTimeout(() => {
                    urlApiEd(
                      adminPanelAPIs.ProductAttchment.addProductAttchmentURL,
                      {
                        photo: img,
                        productId: e.id,
                      }
                    )
                      .then((e) => {})
                      .catch((e) => {});
                  }, i * 1000);
                });
                info?.map((info) => {
                  urlApiEd(
                    adminPanelAPIs.ProductMoreInfo.addProductMoreInfoURL,
                    {
                      key: info.key,
                      value: info.value,
                      productId: e.id,
                    }
                  ).then((e) => {});
                });

                /* setData({
                  name: "",
                  price: 0,
                  discount: 0,
                  brand: 0,
                  description: "",
                  outofstock: false,
                });*/
                setLoad(false)

              })
              .catch((e) => {
           
                setError(true)
                setLoad(false)
              });
          }}
        />

        <BtnAdmin title={"Back to List"} bgcolor="blue" onclick={()=>{
          navigate(-1)
        }} />
      </div>
      <CanvasInCenter showcenter={error} setError={setError}>
        <div className= " my-3 mx-2">
        Make sure you enter all the data.
        </div>
      </CanvasInCenter>
      {load?<Loader/>:''}
    </div>
  );
}
/* import React, { useContext, useState } from "react";



export default function AddProduct() {
  const { dataBrand } = useContext(ContextPro);
  const navigate = useNavigate();
  const location = useLocation();
  const [info, setInfo] = useState([]);
  const [data, setData] = useState({
    categoryId: location.state.id,
              
   
  });
  const [img, setImg] = useState([]);
  function getImg(imgs) {
    setImg([]);
    imgs?.map((e) => {
      setImg((prev) => [...prev, Based64(e)]);
    });
  }
  console.log(data , location, dataBrand);

  return (
    <div className=" container">
      <div className=" brand-data">
        <InputComponent title={"Name"}>
          <input
            type="text"
            value={data.title}
            onChange={(e) => {
              setData({...data, title: e.target.value });
            }}
          />
        </InputComponent>
        <InputComponent title={"Price"}>
          <input
            type="number"
            value={data.price}
            onChange={(e) => {
              setData({ ...data, price: parseInt(e.target.value) });
            }}
          />
        </InputComponent>
        <InputComponent title={"Discount"}>
          <input
            type="number"
            value={data.discount}
            onChange={(e) => {
              setData({ ...data, discount: parseInt(e.target.value) });
            }}
          />
        </InputComponent>
        <InputComponent title={"Brands"}>
          <select
            value={data.brandId}
            onChange={(e) => {
              setData({ ...data, brandId: e.target.value });
            }}
          >
            {dataBrand?.map((e) => (
              <option value={e.id}>{e.name}</option>
            ))}
          </select>
        </InputComponent>
        <InputComponent title={"Description"}>
          <textarea
            value={data.description}
            onChange={(e) => {
              setData({ ...data, description: e.target.value });
            }}
          ></textarea>
        </InputComponent>

        <InputComponent title={"Photo File"}>
          <ChooseImg onclick={getImg} />
        </InputComponent>
        <div className=" align-self-center">
          <input
            type="checkbox"
            value={data.outOfStock}
            onChange={(e) => {
              setData({ ...data, outOfStock: e.target.value });
            }}
          />
          <label>Out of stock</label>
        </div>
        <AddSomeInfo onclick={setInfo} />
      </div>
      <div className=" d-flex gap-4">
        <BtnAdmin
          title={"Creat"}
          bgcolor="green"
          onclick={() => {
            urlApiEd(adminPanelAPIs.Product.addProductURL, data)
              .then((e) => {
                img?.map((img) => {
                  urlApiEd(
                    adminPanelAPIs.ProductAttchment.addProductAttchmentURL,
                    {
                      photo: img,
                      productId: e.id,
                    }
                  )
                    .then((e) => console.log(e))
                    .catch((e) => console.log(e));
                });
                info?.map((info) => {
                  urlApiEd(
                    adminPanelAPIs.ProductMoreInfo.addProductMoreInfoURL,
                    {
                      key: info.key,
                      value: info.value,
                      productId: e.id,
                    }
                  ).then((e) => console.log(e));
                });
                navigate(-1);
              })
              .catch((e) => console.log(e));
          }}
        />

        <BtnAdmin title={"Back to List"} bgcolor="blue" />
      </div>
    </div>
  );
}
 */
